import { gql } from "apollo-boost";

const RESET_PASSWORD = gql`
  mutation reset_password($data: String, $email: String!) {
    reset_password(data: $data, email: $email) {
      analytics_data {
        user_id
        user_type
        flow
      }
    }
  }
`;

export default RESET_PASSWORD;
